<template>
  <div class="misc-wrapper">
      <b-link class="brand-logo" :to="{name : 'login'}">
        <b-img :src="appLogoImage" :alt="'Logo ' + appName" width="40" height="40"/>
        <h2 class="brand-text text-primary m-auto pl-1">{{ appName }}</h2>
      </b-link>

    <div class="misc-inner p-2 p-sm-3 mt-3">
      <div class="w-100 text-center">
        <h1 class="mb-3"> {{$t('Privacy Policy')}} 🔐 </h1>
        <div v-html="data" class="text-left"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import SettingsModule from '../settings/SettingsModule'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'

export default {
  components: { BLink, BImg, },
  setup(){
    const { appName, appLogoImage } = $themeConfig.app
    const MODULE_NAME = 'settings'
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, SettingsModule)
    onUnmounted(() => { if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME) })
    return { appName, appLogoImage, }
  },
  data() {
    return {
      data: ''
    }
  },
  created() {
    store.dispatch('settings/privacy')
        .then(response => {
        this.data = response.data
    })
    .catch(error => {

    })
  }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/pages/page-misc.scss';
.misc-wrapper .misc-inner {
    position: relative;
    max-width: 1200px;
}
</style>
